const HEADER_OFFSET = 96;

export function scrollToSection(id, behavior = 'smooth') {
    const el = document.getElementById(id);
    if (!el) return false;

    const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior });
    return true;
}

export function scrollToSectionWhenReady(id, options = {}) {
    const {
        maxAttempts = 40,
        intervalMs = 50,
        initialDelayMs = 0,
        behavior = 'smooth',
    } = options;

    let attempts = 0;
    let timerId;
    let cancelled = false;

    const tryScroll = () => {
        if (cancelled) return;
        if (scrollToSection(id, behavior)) return;
        if (attempts < maxAttempts) {
            attempts += 1;
            timerId = window.setTimeout(tryScroll, intervalMs);
        }
    };

    timerId = window.setTimeout(tryScroll, initialDelayMs);

    return () => {
        cancelled = true;
        window.clearTimeout(timerId);
    };
}
